import CryptoJS from "crypto-js";

const settingEncryption = (name, data, password) => {
  let dataEncrypted = CryptoJS.AES.encrypt(data, password);
  localStorage.setItem(name, dataEncrypted);
};

export default settingEncryption;
